import React from "react";
import PageTemplate from "./PageTemplate.jsx";

function FormTemplate({
  children,
  className = "",
  title,
  showTitle = true,
  loading = false,
  message = "",
  error = null,
  onRetry = null,
}) {
  return (
    <PageTemplate
      className={className}
      title={title}
      showTitle={showTitle}
      containerClassName="max-w-4xl mx-auto"
    >
      {loading && (
        <div className="mb-6 text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-500 mx-auto"></div>
          <p className="text-gray-600 mt-2">Processing...</p>
        </div>
      )}

      {message && (
        <div className="mb-6 p-4 bg-green-100 border border-green-400 text-green-700 rounded-lg">
          {message}
        </div>
      )}

      {error && (
        <div className="mb-6 p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg">
          <p>{error}</p>
          {onRetry && (
            <button
              onClick={onRetry}
              className="btn btn-danger mt-2"
            >
              Retry
            </button>
          )}
        </div>
      )}

      <div className="bg-white rounded-xl shadow-lg p-8 max-w-4xl mx-auto">
        {children}
      </div>
    </PageTemplate>
  );
}

export default FormTemplate;
